import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import PurchaseCancelRequestFields from './PurchaseCancelRequestFields'

export const PurchaseCancelRequestEdit = props => (
    <Edit {...props} actions={null}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <PurchaseCancelRequestFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default PurchaseCancelRequestEdit
